import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const seq = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "New trial signup", { props: { triggerType: "Tag Added", tag: "trial-started", event: "trial-started" } }],
  ["e1", "auto-email", "Welcome — first 3 steps", { props: { subject: "Welcome! Do these 3 things first" } }],
  ["w1", "auto-wait", "Wait 2 days", { props: { duration: "2", unit: "days" } }],
  ["c1", "auto-condition", "Activated?", { props: { condition: "Has tag 'activated'" } }],
  ["e2", "auto-email", "Activation nudge", { props: { subject: "Stuck? Here's the 5-minute version" } }],
  ["w2", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["e3", "auto-email", "Case study + upgrade", { props: { subject: "How Acme saved 6 hrs/week" } }],
]);

const def: TemplateDef = {
  slug: "saas-trial-onboarding",
  name: "SaaS Trial Onboarding",
  category: "SaaS",
  tagline:
    "Turn trial signups into activated, paying users with a 7-day guided sequence.",
  description:
    "A free SaaS trial onboarding funnel template: landing page → signup → a 7-day activation email sequence with an activated-check branch, ending in an upgrade page. Clone it into FrazzleCRM and the diagram becomes a real automation.",
  whatsInside: [
    "Landing + signup pages wired to a 7-day onboarding flow",
    "Welcome email, activation nudge, and case-study upgrade email",
    "An If/Else branch so activated users skip the nudge",
    "Upgrade checkout and thank-you page at the end of the journey",
  ],
  flow: makeFlow(
    [
      node("src1", "traffic-seo", "SEO / Organic", 40, 60, { props: { keywords: "your category + alternatives" } }),
      node("src2", "traffic-google", "Google Ads", 40, 220),
      node("lp", "page-landing", "Landing page", 360, 140, { props: { headline: "Ship faster with ___" } }),
      node("su", "page-optin", "Signup page", 680, 140, { props: { magnet: "14-day free trial" } }),
      flow("f1", "Trial Onboarding", 1000, 40, 420, 760),
      ...seq.nodes,
      node("up", "page-checkout", "Upgrade", 1520, 340, { props: { price: "$29/mo" } }),
      node("ty", "page-thankyou", "Welcome aboard", 1840, 340),
      node("n1", "util-note", "Pro tip", 680, 340, {
        notes:
          "Fire the 'activated' tag from your app the moment a user hits their aha-moment — the branch below does the rest.",
      }),
    ],
    [
      edge("src1", "lp"),
      edge("src2", "lp"),
      edge("lp", "su"),
      edge("su", "f1"),
      ...seq.edges,
      edge("f1", "up"),
      edge("up", "ty"),
    ]
  ),
};

export default def;
